import React from 'react';

// Packages
import { BrowserRouter as  Router, Routes, Route, Navigate  } from 'react-router-dom';
import { ConfigProvider, Layout, message } from 'antd';
import en from 'antd/locale/en_US';
import es from 'antd/locale/es_ES';

// Redux
import { Provider } from 'react-redux';
import store from './store';

// Components
import PrivateRoute from './router/PrivateRoute';
import Authentication from './components/main/Authentication';
import Header from './components/main/Header';
import Footer from './components/main/Footer';
import NotFound from './components/main/NotFound';
import NotAuth from './components/main/NotAuth';
import Tutorials from './components/tutorials/Tutorials';
import Files from './components/files/Files';
import FileLogs from './components/files/FileLogs';

// Actions
import { user_token_check } from './actions/authActions';

user_token_check (store);

const App = () => {
	const [messageApi, contextHolder] = message.useMessage();

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: '#42506b'
				}
			}}
			locale={localStorage.getItem('language') === 'es' ? es : en}
		>
		<Provider store={store}>
			<Router>
				<Layout className='layout'>
					{contextHolder}
					<Header />

					<Layout.Content className='content'>
						<Routes>
							<Route path='/auth' element={ <Authentication /> } exact />

							<Route element={ <PrivateRoute /> } exact>
								{/* Redirect "/" to "/videos" for authenticated users */}
								<Route path='/' element={ <Navigate replace to="/videos" /> } />

								{/* Videos */}
								<Route path='/videos' element={ <Tutorials /> } />

								{/* Files */}
								<Route path='/files' element={ <Files messageApi={messageApi} /> } />
								<Route path='/files/:file_id/logs' element={ <FileLogs messageApi={messageApi} /> } />

								{/* Route for displaying the "Not Authorized" page when users lack permission to view a page */}
								<Route path='/access-denied' element={ <NotAuth /> } />
							</Route>

							 {/* Other */}
							<Route path='*' element={ <NotFound /> } />
						</Routes>
					</Layout.Content>
					
					<Footer />
				</Layout>
			</Router>
		</Provider>
		</ConfigProvider>
	);
};

export default App;
